// extracted by mini-css-extract-plugin
export default {"button":"BaseButton_button__3nsT0","buttonBig":"BaseButton_buttonBig__FLzL-","buttonIcon":"BaseButton_buttonIcon__5yzOx"};